import { Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onDiscard: () => void;
    onCancel: () => void;
};

const DiscardChangesModal = ({ open, onDiscard, onCancel }: Props) => (
    <ConfirmationModal
        open={open}
        type="warning"
        icon={<ExclamationCircleOutlined />}
        title="Discard unsaved changes?"
        confirmButtonText="Discard Changes"
        cancelButtonText="Keep Editing"
        onConfirm={onDiscard}
        onCancel={onCancel}
        onClose={onCancel}
        content={
            <Typography>
                Some of the values you entered haven't been saved yet. If you leave now, those changes will be lost.
            </Typography>
        }
    />
);

export default DiscardChangesModal;
